import { forwardRef, useImperativeHandle } from 'react'
import { Button, Grid, Chip, Typography, makeStyles } from '@material-ui/core'

import FormField from 'components/form/FormField'

import useForm from 'hooks/useForm'
import { validations } from './validations'
import { REGEXP } from 'utils/constants'

const useStyles = makeStyles({
   root: {
      padding: '20px',
      gap: '10px',
      maxWidth: '600px'
   },
   actions: {
      justifyContent: 'space-between',
      marginTop: '20px'
   }
})

const defaultValues = {
   emails: []
}

const UserInternalForm = forwardRef(({ onSubmit }, ref) => {
   const classes = useStyles()
   const { form, createControlledComponent } = useForm({ validations, defaultValues })
   const ControlledFormField = createControlledComponent(FormField)

   const emails = form.watch('emails')

   const handleInputChange = e => {
      if (e.key === ' ' || e.key == 'Enter') {
         e.preventDefault()
         const value = e.target.value
         form.setValue('emails', [...emails, ...(value?.split(' ') ?? [])])
         form.trigger('emails')
      }
   }

   const handleClear = () => {
      form.reset()
   }
   useImperativeHandle(ref, () => ({
      reset: handleClear
   }))

   return (
      <form onSubmit={form.handleSubmit(onSubmit)}>
         <Grid container direction="column" className={classes.root}>
            <Typography variant="body2">Completa los campos</Typography>
            <ControlledFormField
               fieldName="emails"
               fieldLabel="Correo Electrónico"
               type="autocomplete"
               freeSolo
               multiple
               limitTags={5}
               options={[]}
               required
               disableCloseOnSelect
               onKeyDown={handleInputChange}
               renderTags={(value, getTagProps) =>
                  value?.map((option, index) => {
                     const item = option?.email ?? option
                     return (
                        <Chip
                           label={item}
                           {...getTagProps({ index })}
                           key={item + index}
                           color={Boolean(REGEXP.EMAIL.test(item)) ? 'inherit' : 'secondary'}
                        />
                     )
                  })
               }
            />
            <Grid container className={classes.actions}>
               <Button
                  variant="contained"
                  type="submit"
                  disableElevation
                  color="primary"
                  disabled={form.formState.touchedFields && !form.formState.isValid}
               >
                  Guardar
               </Button>
               <Button variant="outlined" onClick={handleClear}>
                  Limpiar
               </Button>
            </Grid>
         </Grid>
      </form>
   )
})

export default UserInternalForm
